<template>
  <!-- 修改工资密码 -->
  <div class="changePassword">
    <van-nav-bar :title="$t('changeSalaryPsw.sapsTxt1')"
                 left-text=""
                 left-arrow
                 @click-left="onClickLeft"
                 @click-right="onClickRight" />
    <div>
      <!-- :rules="[{ required: true, message: '请填写原密码' }]" -->
      <van-form @submit="onSubmit">
        <van-field v-model="oldPassword"
                   required
                   readonly
                   clickable
                   type="password"
                   name="oldPassword"
                   :label="$t('changeSalaryPsw.sapsTxt2')"
                   :placeholder="$t('changeSalaryPsw.sapsTxt2')"
                   @touchstart.native.stop="showBoard(1)" />
        <van-number-keyboard v-model="oldPassword"
                             :show="showBoard1"
                             :maxlength="6"
                             @blur="showBoard1 = false" />
        <van-field v-model="newPassword1"
                   required
                   readonly
                   clickable
                   type="password"
                   name="newPassword1"
                   :label="$t('changeSalaryPsw.sapsTxt3')"
                   :placeholder="$t('changeSalaryPsw.sapsTxt3')"
                   @touchstart.native.stop="showBoard(2)" />
        <van-number-keyboard v-model="newPassword1"
                             :show="showBoard2"
                             :maxlength="6"
                             @blur="showBoard2 = false" />
        <van-field v-model="newPassword2"
                   required
                   readonly
                   clickable
                   type="password"
                   name="newPassword2"
                   :label="$t('changeSalaryPsw.sapsTxt4')"
                   :placeholder="$t('changeSalaryPsw.sapsTxt4')"
                   @touchstart.native.stop="showBoard(3)" />
        <van-number-keyboard v-model="newPassword2"
                             :show="showBoard3"
                             :maxlength="6"
                             @blur="showBoard3 = false" />
        <!-- <p class="pswDesc">
          密码必须是8-16位的英文字母、数字、字符组合（不能 是纯数字）
        </p> -->
        <div style="margin: 16px;">
          <van-button round
                      block
                      type="info"
                      :disabled="!canSave"
                      native-type="submit">{{$t('module.submit')}}</van-button>
        </div>
        <div class="forgetPwd">
          <span @click="getSms">{{$t('changeSalaryPsw.sapsTxt5')}}</span>
        </div>
      </van-form>
    </div>
    <!-- 重置密码弹窗 -->
    <entSMS ref="entSMS"
            @beforeClose="beforeClose" />
  </div>
</template>

<script>
import { Toast } from 'vant'
import { NumberKeyboard } from 'vant';
import entSMS from '@components/entSMS'
import { changeSalaryPwd, setSalaryPwd } from "@api/wx.js"
export default {
  components: {
    entSMS
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.userInfo) || {},
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      showBoard1: false,
      showBoard2: false,
      showBoard3: false
    }
  },
  computed: {
    canSave () {
      if (this.oldPassword && this.newPassword1 && this.newPassword2 && this.newPassword1 == this.newPassword2)
      {
        return true
      } else
      {
        return false
      }
    }
  },
  methods: {
    showBoard (val) {
      if (val == 1)
      {
        this.showBoard1 = true
        this.showBoard2 = false
        this.showBoard3 = false
      } else if (val == 2)
      {
        this.showBoard1 = false
        this.showBoard2 = true
        this.showBoard3 = false
      } else if (val == 3)
      {
        this.showBoard1 = false
        this.showBoard2 = false
        this.showBoard3 = true
      }
    },
    onClickLeft () {
      this.$router.push("/personCen");
    },
    onClickRight () { },
    // 提交
    onSubmit (values) {
      const data = {
        empcode: this.userInfo.empcode,
        oldpwd: values.oldPassword,
        newpwd1: values.newPassword1,
        newpwd2: values.newPassword2,
      }
      changeSalaryPwd(data).then(res => {
        if (res.iserror === '0')
        {
          Toast.success(this.$t('changeSalaryPsw.sapsTxt6'))
        }
      })
    },
    // 忘记密码
    getSms () {
      this.$refs.entSMS.show = true
    },
    // 验证码框关闭
    beforeClose (action) {
      if (action === 'confirm')
      {
        // 验证码正确，重置页面
        this.$router.push("/resetSalaryPsw")
        this.$refs.entSMS.show = false
        this.$refs.entSMS.s = 0
        // this.$emit('beforeClose', action)
      } else
      {
        // 取消获取验证码
        // 重新登录
        // this.goLogin()
        this.$refs.entSMS.show = false
        this.$refs.entSMS.s = 0
      }
    },
  }
}
</script>

<style lang="less" scoped>
.changePassword {
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .van-form {
    .pswDesc {
      padding: 20px 30px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 40px;
      color: #333333;
    }
    .forgetPwd {
      text-align: right;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 40px;
      color: #1989fa;
      span {
        padding: 20px;
      }
    }
  }
}
</style>